import React, {Component} from 'react';
import PropTypes from 'prop-types';

export class ErrorComponent extends Component {

  buildHeader( text ) {
    // can make this as fancy as we want
    return <h1>{text}</h1>;
  }

  buildBody ( text ) {
    // can make this as fancy as we want
    return <p>{text}</p>;
  }

  render() {

    const { errorHeaderText, errorBodyText } = this.props;

    return (
      <div>
        {this.buildHeader(errorHeaderText)}
        {this.buildBody(errorBodyText)}
      </div>
    );
  }
}

ErrorComponent.propTypes = {
  errorHeaderText: PropTypes.any.isRequired,
  errorBodyText: PropTypes.any.isRequired
};

export default (ErrorComponent);
